export default [
  'BOTRegionLocations',
  'BOTRegionalDetails'
]

/*
Appears on:
/regions/bay-area
*/
